import { Button } from "@/components/ui/button"
import { ArrowRight } from "lucide-react"
import { Link } from "react-router-dom"

export default function HeroSection() {
  return (
    <section className="container mx-auto px-4 py-16 md:py-24" style={{ maxWidth: "1400px" }}>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
        <div>
          <div className="inline-block px-4 py-2 bg-purple-800/50 rounded-full text-purple-200 mb-6">
            Lavender Flow
          </div>
          <h1 className="text-4xl md:text-6xl font-bold text-black leading-tight mb-6">
            The next generation of AI workflows
          </h1>
          <p className="text-lg text-black mb-8 max-w-xl">
            Build and deploy multimodal AI agent pipelines with our visual, node-based platform. Supporting text,
            images, video, audio, and real-time streaming data for developers and teams.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <Button className="bg-purple-500 hover:bg-purple-600 text-white !px-6 py-6 text-lg shadow-lg transition-all duration-200 cursor-pointer">
              Get started
              <ArrowRight className="ml-2 h-5 w-5" />
            </Button>
            <Link to="/gallery/workflows">
              <Button
                variant="outline"
                className="text-purple-50 bg-indigo-900/75 hover:bg-indigo-900 hover:text-white !px-6 py-6 shadow-lg text-lg transition-all duration-200 cursor-pointer"
              >
                See Workflows
              < ArrowRight className="ml-2 h-5 w-5" />
              </Button>
            </Link>
          </div>
        </div>
        <div className="relative hidden md:block">
          <img
            src="/assets/placeholder.svg?height=500&width=600"
            alt="Lavender Flow UI illustration showing connected nodes and workflow"
            className="rounded-lg"
          />
          <div className="absolute -bottom-6 -left-6 w-32 h-32 bg-purple-400 rounded-full opacity-70 blur-xl"></div>
          <div className="absolute top-10 -right-10 w-40 h-40 bg-purple-300 rounded-full opacity-60 blur-xl"></div>
        </div>
      </div>
    </section>
  )
}
